import { PortOrAddress } from 'features/Directory'
import { TransportPlanExtractor } from 'features/TransportPlan'
import { isNumber } from 'lodash-es'

import { ShipmentInterface } from '../domain/ShipmentInterface'

export const pickup = (shipment: ShipmentInterface): PortOrAddress => {
  const tpExtractor = new TransportPlanExtractor()
  if (shipment?.tp) {
    const originAddresses = tpExtractor.getOriginAddresses(shipment.tp)

    return originAddresses[0] || ({} as PortOrAddress)
  }
  return shipment?.origin || ({} as PortOrAddress)
}

export const delivery = (shipment: ShipmentInterface): PortOrAddress => {
  const tpExtractor = new TransportPlanExtractor()
  if (shipment?.tp) {
    const deliveryAddresses = tpExtractor.getDestinationAddresses(shipment.tp)

    return deliveryAddresses[0] || ({} as PortOrAddress)
  }
  return shipment?.destination || ({} as PortOrAddress)
}

export const isPositive = (value: number): boolean => {
  return Boolean(value && isNumber(value) && Number(value) > 0)
}
